/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import {Framebuffer} from "App/utils/frame_buffer";
import WebGLContext from "App/web_gl_context";

export default
class ScreenFrameBuffer {
    protected fboID: WebGLFramebuffer;
    protected framebuffer: Framebuffer;
    protected _context: WebGLContext;
    private _data: Uint8Array;

    constructor(aFramebufferUtil: Framebuffer) {
        this.framebuffer = aFramebufferUtil;
        this._context = aFramebufferUtil.getWebGLContext();

        this.fboID = null;

        // 4 = 1 * 1 * 4;
        this._data = new Uint8Array(4 * 1 * 1);
    }
    
    public initialize() {
        this.fboID = null;
    }

    public bind() {
        let gl = this._context.getWebGLRenderingContext();
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.fboID);
    }

    public unbind() {
        let gl = this._context.getWebGLRenderingContext();
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
    }

    public getData(aX: number, aY: number, aWidth: number, aHeight: number, aFormat: number, aType: number): Uint8Array {
        let gl = this._context.getWebGLRenderingContext();
        this.bind();
        gl.readPixels(aX, aY, aWidth, aHeight, aFormat, aType, this._data);

        return this._data;
    }

    public release() {
        this.fboID = null;
    }
}
